import { store } from "@app/dev/index/terminalApp";
import { getAuthData } from "@common/helpers/auth";
import { fetchRequest } from "@common/helpers/util/requestMiddleware";

const HIPAY_TOKEN = "SOstgXQJ44Pa1u298aL1e451IUta1nCO";

class DepositServiceHiPay {
  static async createOrder(amount) {
    const { tid, currency, betshopid: betshopId } = getAuthData();
    const startupSettings = store.getState().terminal.startupSettings;

    try {
      const res = await fetchRequest("https://betshop-payments.betcoapps.com", "api/hipay/createorder", "POST", {
        body: {
          amount,
          currency,
          betshopId: +betshopId,
          terminalId: +tid,
          token: HIPAY_TOKEN,
          terminalName: startupSettings.TerminalName,
          betshopName: startupSettings.BetshopName,
        },
      });

      if (res.success) {
        const parser = new DOMParser();
        const xmlDoc = parser.parseFromString(res.data, "text/xml");
        const forwardUrl = xmlDoc.getElementsByTagName("forward_url")?.[0]?.textContent;
        const errorText = xmlDoc.getElementsByTagName("message")?.[0]?.textContent;

        if (forwardUrl) return { forwardUrl };
        return { errorText };
      }

      return { errorText: "Something went wrong" };
    } catch {
      return { errorText: "Something went wrong" };
    }
  }
}

export default DepositServiceHiPay;
